import { useMutation } from '@tanstack/react-query';
import { ApiClient, useApiClient } from 'api/context-provider/useApiClient';
import { ApiError, InferFetchData, throwOnError } from 'api/helpers';
import { queryClient } from 'configs/queryClient';

async function cancelSubscription(apiClient: ApiClient, subscriptionId: number) {
  return apiClient.PUT('/op/v2/subscriptions/{id}/cancel', {
    params: { path: { id: subscriptionId } },
  });
}

export function useCancelSubscriptionMutation() {
  const apiClient = useApiClient();
  return useMutation<InferFetchData<typeof cancelSubscription>, ApiError, { subscriptionId: number }>({
    mutationKey: ['CancelSubscription'],
    mutationFn: (data) => throwOnError(cancelSubscription(apiClient, data.subscriptionId)),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['workshop'] });
    },
  });
}
